module.exports = __webpack_public_path__ + "media/images/redesign-images/home/home-2-f807335a32ad0657398c0e0ca2af5499.jpg";